import React, { Component } from "react";

import LazyInputRange from "./LazyInputRange";

const parseNumber = (value, defaultValue) => {
  if (typeof value === "number") {
    return value;
  }
  return value ? parseInt(value, 10) : defaultValue;
};

class RangeItem extends Component {
  static defaultProps = {
    onChange: () => {}
  };

  constructor(props) {
    super(props);

    const { submittedResponse } = props;
    this.state = { body: submittedResponse ? submittedResponse.body : null };
  }

  handleChange = body => {
    const { onChange, surveyItem } = this.props;

    this.setState({ body });
    onChange({ surveyItemId: surveyItem.id, body });
  };

  render() {
    const { surveyItem } = this.props;
    const { body } = this.state;

    const maxRange = parseNumber(surveyItem.maxRange, 5);
    const minRange = parseNumber(surveyItem.minRange, 1);

    return (
      <div className={`SurveyItemRange clearfix ${body ? "touched" : "untouched"}`}>
        <LazyInputRange
          maxValue={maxRange}
          minValue={minRange}
          value={body || minRange}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export default RangeItem;
